export default class BaseResponse {
    public processed: boolean;
    public errorMessage?: string;

    constructor(processed: boolean, errorMessage: string|undefined = undefined) {
        this.processed = processed;
        this.errorMessage = errorMessage;
    }
}
